export default "__VITE_ASSET__7rjE32WZ__"